<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100">
            <div class="info-body">
                <div class="info-left">
                    <el-image class="big-img" fit="scale-down" :src="info.signboard.imgList2[actIndex]"></el-image>
                </div>
                <div class="info-right">
                    <div class="user-body">
                        <div class="user-title" @click="$router.go(-1)">返回到招牌享阅“{{info.signboard.title}}”</div>
                        <el-image class="head-img" :src="info.head_url" fit="cover"></el-image>
                    </div>
                    <div class="img-list-body">
                        <div class="img-list-b">
                            <div v-for="(vo,key) in info.signboard.imgList2" class="imgs-body">
                                <el-image class="imgs-url" fit="cover" @click="onClickImg(key)" :src="vo" ></el-image>
                                <div v-if="key == actIndex" class="act-i"></div>
                                <div v-else style="height: 10px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片
    export default {
        components: {
            Topheader
        },
        name: "zpImgsInfo",
        data() {
            return {
                actIndex: 0,
                id: '',
                info:{
                    signboard:{
                        imgList2:[]
                    }
                },
            };
        },
        created() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#494949");
            this.id=this.$route.query.id;
            this.getInfo();
        },
        //方法定义
        methods: {
            //点击图片
            onClickImg(index){
                this.actIndex=index;
            },
            getInfo(){
                let _this=this;
                _this.common.request('api/dynamic/info',{id:_this.id},function (res) {
                    if(res.status == 200){
                        _this.info=res.data.info;
                    }
                })
            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">

    .info-body{
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
    }

    .user-body{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .user-title{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        cursor: pointer;
    }
    .user-title:hover{
        color:rgba(255,255,255,0.8);

    }
    .head-img{
        width:48px;
        height:48px;
        border-radius:50%;
        margin-left: 16px;
    }

    .banner-body{
        height: 109px;
    }

    .title-t{
        font-size:24px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:54px;
        margin-top: 30px;
    }

    .info-left{
        width:462px;
        height:628px;
        display: flex;
        align-items: center;
    }

    .info-right{
        width: 600px;
    }

    .big-img{
        width:462px;
    }

    .img-list-body{
        width: 600px;
        height: 580px;
        overflow: hidden;
    }
    .img-list-b{
        width: 620px;
        max-height: 580px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
    }
    .imgs-url{
        height:126px;
    }
    .imgs-body{
        width:126px;
        margin-top: 10px;
        margin-left: 20px;
        cursor: pointer;
    }
    .act-i{
        width:10px;
        height:10px;
        background:rgba(40,235,19,1);
        border-radius:50%;
        margin: 0 auto;
    }

</style>


// WEBPACK FOOTER //
// src/view/zpImgsInfo.vue